<template>
  <HpsfirProDrawer
    v-model:open="visible"
    title="配置发布"
    width="70vw"
    max-width="980px"
    content-class="publish-drawer"
    body-class="publish-drawer__body"
    footer-class="publish-drawer__footer"
  >
    <div class="publish-drawer__content">
      <div class="publish-drawer__tpl-card">
        <div>
          <div class="publish-drawer__tpl-label">模板名称</div>
          <div class="publish-drawer__tpl-value">{{ tpl?.name || '未知' }}</div>
        </div>
        <div>
          <div class="publish-drawer__tpl-label">模板版本</div>
          <div class="publish-drawer__tpl-value">{{ tpl?.currentVersion || '未知' }}</div>
        </div>
      </div>

      <HpsfirProForm
        v-if="visible && items.length"
        ref="setFormRef"
        :init-form-value="initValues"
        title="配置模板"
        :items="items"
        :hide-cancel="true"
        :hide-ok="true"
        @change="handleFormChange"
      />
    </div>
    <template #footer>
      <HpsfirButton variant="outline" @click="() => visible = false">取消</HpsfirButton>
      <HpsfirButton @click="handlePublish" :disabled="loading">发布</HpsfirButton>
    </template>
  </HpsfirProDrawer>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, watch } from 'vue';

const emit = defineEmits<{(e: 'close'): void;}>();

const setFormRef = ref<any>();

const visible = ref(false);
const weapp = ref({} as any);
const tpl = ref<any>();

const items = ref<HpsfirProFormItem[]>([]);

const initValues = ref({} as any);

watch(visible, () => {
  if (!visible.value) {
    emit('close');
  }
});

const loading = ref(false);

const formData = ref({} as any);

const handleFormChange = useBaseAsync((data: any) => {
  formData.value = { ...data };
});

const handlePublish = useBaseAsync(async() => {
  try {
    loading.value = true;
    await useApi().weappApi.publishWeappweapp({
      appid: weapp.value.appid,
      ext: formData.value,
    });
    ElMessage.success('提交发布审核成功');
    visible.value = false;
  } finally {
    loading.value = false;
  }
});

defineExpose({
  show: async(_weapp: any, _tpl: any) => {
    let tenant: any;
    try {
      const res = await useApi().tenantApi.getTenantComInfotenant();
      if (res?.data?.data) {
        tenant = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }

    weapp.value = _weapp;
    tpl.value = _tpl;
    initValues.value = {};
    formData.value = {};
    items.value = _tpl?.extjsFormItems?.map((item: any) => {
      if (_weapp.ext?.[item.name] !== undefined) {
        initValues.value[item.name] = _weapp.ext?.[item.name];
      } else if (item.tenantKey && tenant?.[item.tenantKey]) {
        initValues.value[item.name] = tenant?.[item.tenantKey];
      }
      if (item.required) {
        item.rule = [{ required: true }];
      }
      if (item.type === 'image') {
        return {
          ...item,
          action: useApi().uploadImageUrl,
          multiple: false,
          onSuccess(data: any) {
            setFormRef.value?.setOneFormState(item.name, data.data[0]);
          },
        };
      }
      return item;
    }) || [];
    visible.value = true;
  },
});
</script>
<style lang="scss" scoped>
.publish-drawer__content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.publish-drawer__tpl-card {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 16px;
  border: 1px solid color-mix(in srgb, var(--border, #e5e7eb) 72%, transparent);
  border-radius: 16px;
  background: color-mix(in srgb, var(--muted, #f3f4f6) 32%, transparent);
}

.publish-drawer__tpl-label {
  color: var(--muted-foreground, #6b7280);
  font-size: 12px;
}

.publish-drawer__tpl-value {
  margin-top: 4px;
  color: var(--foreground, #111827);
  font-weight: 700;
}

:global(.publish-drawer) {
  width: min(980px, 70vw) !important;
}

:global(.publish-drawer__body) {
  padding: 12px !important;
  overflow: auto;
}

:global(.publish-drawer__footer) {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

@media (max-width: 767px) {
  .publish-drawer__tpl-card {
    grid-template-columns: 1fr;
  }

  :global(.publish-drawer) {
    width: 100vw !important;
    max-width: 100vw !important;
  }

  :global(.publish-drawer__body) {
    padding: 8px !important;
  }
}
</style>
